module.exports = __webpack_public_path__ + "afff36f103252ab4a2beffe48249eb06.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/test-step-2.svg
// module id = 486
// module chunks = 0